import React, { useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { GetStartedForm } from '../components/GetStartedForm';
import { Bot, ShoppingCart, LineChart, Users, MessageSquare, FileText, Database, Mail, Calendar, Search, Filter, Star } from 'lucide-react';
export function AgentsPage() {
  const [activeFilter, setActiveFilter] = useState('all');
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState('');
  const handleAgentAction = agentName => {
    setSelectedAgent(agentName);
    setIsFormOpen(true);
  };
  return <div className="flex flex-col min-h-screen w-full" data-id="element-456">
      <Header data-id="element-457" />
      <main className="flex-grow" data-id="element-458">
        {/* Hero Section */}
        <div className="bg-black text-white py-16 md:py-24" data-id="element-459">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-460">
            <div className="text-center" data-id="element-461">
              <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-462">
                Agent Gallery
              </h1>
              <p className="text-xl md:text-2xl max-w-3xl mx-auto text-gray-300" data-id="element-463">
                Browse our collection of pre-built AI agents ready to transform
                your business operations.
              </p>
            </div>
          </div>
        </div>
        {/* Filter Section */}
        <div className="bg-white border-b border-gray-200" data-id="element-464">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-id="element-465">
            <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-466">
              <div className="flex items-center mb-4 md:mb-0" data-id="element-467">
                <Filter className="text-gray-500 mr-2" size={20} data-id="element-468" />
                <span className="text-gray-700 font-medium mr-4" data-id="element-469">
                  Filter by:
                </span>
                <div className="flex flex-wrap gap-2" data-id="element-470">
                  <FilterButton label="All Agents" active={activeFilter === 'all'} onClick={() => setActiveFilter('all')} data-id="element-471" />
                  <FilterButton label="Customer Service" active={activeFilter === 'customer'} onClick={() => setActiveFilter('customer')} data-id="element-472" />
                  <FilterButton label="Sales" active={activeFilter === 'sales'} onClick={() => setActiveFilter('sales')} data-id="element-473" />
                  <FilterButton label="Operations" active={activeFilter === 'operations'} onClick={() => setActiveFilter('operations')} data-id="element-474" />
                </div>
              </div>
              <div className="relative w-full md:w-64" data-id="element-475">
                <input type="text" placeholder="Search agents..." className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-black" data-id="element-476" />
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} data-id="element-477" />
              </div>
            </div>
          </div>
        </div>
        {/* Featured Agents */}
        <div className="py-12 bg-gray-50" data-id="element-478">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-479">
            <h2 className="text-2xl font-bold mb-8 flex items-center" data-id="element-480">
              <Star className="text-black mr-2" size={24} data-id="element-481" />
              Featured Agents
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-482">
              <FeaturedAgentCard icon={<Bot size={24} data-id="element-484" />} title="Customer Support Agent" description="Handles customer inquiries 24/7, resolves common issues, and escalates complex problems to human agents." category="Customer Service" rating={4.9} reviews={156} onTryAgent={() => handleAgentAction('Customer Support Agent')} data-id="element-483" />
              <FeaturedAgentCard icon={<ShoppingCart size={24} data-id="element-486" />} title="Order Processing Agent" description="Automates the entire order workflow from confirmation to shipping coordination and delivery updates." category="Operations" rating={4.8} reviews={124} onTryAgent={() => handleAgentAction('Order Processing Agent')} data-id="element-485" />
              <FeaturedAgentCard icon={<LineChart size={24} data-id="element-488" />} title="Analytics Assistant" description="Monitors business metrics, generates reports, and sends alerts when important changes are detected." category="Operations" rating={4.7} reviews={98} onTryAgent={() => handleAgentAction('Analytics Assistant')} data-id="element-487" />
            </div>
          </div>
        </div>
        {/* All Agents */}
        <div className="py-16 bg-white" data-id="element-489">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-490">
            <h2 className="text-2xl font-bold mb-8" data-id="element-491">All Agents</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-492">
              <AgentCard icon={<MessageSquare size={24} data-id="element-494" />} title="Live Chat Agent" description="Engages website visitors, answers product questions, and qualifies leads before handing off to sales." category="Customer Service" onViewDetails={() => handleAgentAction('Live Chat Agent')} data-id="element-493" />
              <AgentCard icon={<FileText size={24} data-id="element-496" />} title="Document Processor" description="Extracts key information from documents, categorizes them, and routes them to the appropriate departments." category="Operations" onViewDetails={() => handleAgentAction('Document Processor')} data-id="element-495" />
              <AgentCard icon={<Users size={24} data-id="element-498" />} title="Recruitment Assistant" description="Screens resumes, schedules interviews, and follows up with candidates to accelerate hiring." category="HR" onViewDetails={() => handleAgentAction('Recruitment Assistant')} data-id="element-497" />
              <AgentCard icon={<Database size={24} data-id="element-500" />} title="Data Entry Agent" description="Automatically processes forms and inputs data into your systems with high accuracy." category="Operations" onViewDetails={() => handleAgentAction('Data Entry Agent')} data-id="element-499" />
              <AgentCard icon={<Mail size={24} data-id="element-502" />} title="Email Manager" description="Categorizes incoming emails, responds to routine inquiries, and prioritizes important messages." category="Customer Service" onViewDetails={() => handleAgentAction('Email Manager')} data-id="element-501" />
              <AgentCard icon={<Calendar size={24} data-id="element-504" />} title="Scheduling Assistant" description="Manages your calendar, schedules meetings, and sends reminders to all participants." category="Productivity" onViewDetails={() => handleAgentAction('Scheduling Assistant')} data-id="element-503" />
              <AgentCard icon={<ShoppingCart size={24} data-id="element-506" />} title="Sales Development Agent" description="Qualifies leads, schedules demos, and nurtures prospects through the sales pipeline." category="Sales" onViewDetails={() => handleAgentAction('Sales Development Agent')} data-id="element-505" />
              <AgentCard icon={<LineChart size={24} data-id="element-508" />} title="Market Research Agent" description="Monitors competitors, tracks industry trends, and generates insights for your business." category="Strategy" onViewDetails={() => handleAgentAction('Market Research Agent')} data-id="element-507" />
              <AgentCard icon={<Bot size={24} data-id="element-510" />} title="Custom Agent" description="Build a completely custom agent tailored to your specific business needs and workflows." category="Custom" isCustom={true} onViewDetails={() => handleAgentAction('Custom Agent')} data-id="element-509" />
            </div>
          </div>
        </div>
        {/* Integration Section */}
        <div className="py-16 bg-gray-50" data-id="element-511">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-512">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-513">
              <div data-id="element-514">
                <h2 className="text-3xl font-bold mb-6" data-id="element-515">
                  Seamless Integrations
                </h2>
                <p className="text-lg text-gray-600 mb-6" data-id="element-516">
                  All our agents integrate with your existing software stack.
                  Connect with hundreds of popular tools with just a few clicks.
                </p>
                <div className="grid grid-cols-3 gap-4 mb-6" data-id="element-517">
                  {['Salesforce', 'Slack', 'Gmail', 'Shopify', 'Zendesk', 'Asana', 'HubSpot', 'Trello', 'Notion'].map((tool, index) => <div key={index} className="bg-white py-2 px-3 rounded-lg border border-gray-200 text-center text-sm font-medium" data-id="element-518">
                      {tool}
                    </div>)}
                </div>
                <a href="#" className="text-black font-medium hover:underline" data-id="element-519">
                  View all integrations →
                </a>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-lg" data-id="element-520">
                <h3 className="text-xl font-bold mb-4" data-id="element-521">Integration Example</h3>
                <div className="space-y-4" data-id="element-522">
                  <div className="flex items-start" data-id="element-523">
                    <div className="bg-black text-white p-2 rounded-full mr-3" data-id="element-524">
                      <Bot size={16} data-id="element-525" />
                    </div>
                    <div className="bg-gray-100 rounded-lg p-3 flex-1" data-id="element-526">
                      <p className="text-sm" data-id="element-527">
                        Customer Support Agent connects to:
                      </p>
                      <div className="flex flex-wrap gap-2 mt-2" data-id="element-528">
                        <span className="bg-gray-200 text-xs px-2 py-1 rounded-full" data-id="element-529">
                          Zendesk
                        </span>
                        <span className="bg-gray-200 text-xs px-2 py-1 rounded-full" data-id="element-530">
                          Slack
                        </span>
                        <span className="bg-gray-200 text-xs px-2 py-1 rounded-full" data-id="element-531">
                          Gmail
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="border-l-2 border-gray-200 ml-4 pl-6 py-2" data-id="element-532">
                    <p className="text-sm text-gray-600" data-id="element-533">
                      The agent automatically:
                    </p>
                    <ul className="mt-2 space-y-2 text-sm" data-id="element-534">
                      <li className="flex items-start" data-id="element-535">
                        <span className="bg-black text-white p-1 rounded-full mr-2 mt-0.5" data-id="element-536">
                          <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-537">
                            <polyline points="20 6 9 17 4 12" data-id="element-538"></polyline>
                          </svg>
                        </span>
                        <span data-id="element-539">Retrieves customer data from Zendesk</span>
                      </li>
                      <li className="flex items-start" data-id="element-540">
                        <span className="bg-black text-white p-1 rounded-full mr-2 mt-0.5" data-id="element-541">
                          <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-542">
                            <polyline points="20 6 9 17 4 12" data-id="element-543"></polyline>
                          </svg>
                        </span>
                        <span data-id="element-544">Responds to emails in Gmail</span>
                      </li>
                      <li className="flex items-start" data-id="element-545">
                        <span className="bg-black text-white p-1 rounded-full mr-2 mt-0.5" data-id="element-546">
                          <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-547">
                            <polyline points="20 6 9 17 4 12" data-id="element-548"></polyline>
                          </svg>
                        </span>
                        <span data-id="element-549">Notifies team in Slack when needed</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* CTA Section */}
        <div className="bg-black text-white py-16" data-id="element-550">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-551">
            <h2 className="text-3xl font-bold mb-6" data-id="element-552">
              Find the perfect agent for your business
            </h2>
            <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto" data-id="element-553">
              Start with a pre-built agent or create a custom solution tailored
              to your specific needs.
            </p>
            <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4" data-id="element-554">
              <button onClick={() => handleAgentAction('Pre-built Agent')} className="bg-white text-black px-6 py-3 rounded-lg font-medium hover:bg-gray-100 transition-colors" data-id="element-555">
                Deploy an Agent
              </button>
              <button onClick={() => handleAgentAction('Custom Agent')} className="border border-white text-white px-6 py-3 rounded-lg font-medium hover:bg-gray-900 transition-colors" data-id="element-556">
                Build Custom Agent
              </button>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-557" />
      {/* Contact Form Modal */}
      <GetStartedForm isOpen={isFormOpen} onClose={() => setIsFormOpen(false)} data-id="element-558" />
    </div>;
}
function FilterButton({
  label,
  active,
  onClick
}) {
  return <button className={`px-3 py-1 rounded-full text-sm font-medium transition-colors ${active ? 'bg-black text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} onClick={onClick} data-id="element-559">
      {label}
    </button>;
}
function FeaturedAgentCard({
  icon,
  title,
  description,
  category,
  rating,
  reviews,
  onTryAgent
}) {
  return <div className="bg-white p-6 rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-560">
      <div className="flex items-center space-x-4 mb-4" data-id="element-561">
        <div className="bg-black text-white w-12 h-12 rounded-full flex items-center justify-center" data-id="element-562">
          {icon}
        </div>
        <div data-id="element-563">
          <h3 className="text-xl font-semibold" data-id="element-564">{title}</h3>
          <p className="text-gray-500 text-sm" data-id="element-565">{category}</p>
        </div>
      </div>
      <p className="text-gray-600 mb-6" data-id="element-566">{description}</p>
      <div className="flex justify-between items-center" data-id="element-567">
        <div className="flex items-center" data-id="element-568">
          <div className="flex items-center mr-2" data-id="element-569">
            {[...Array(5)].map((_, i) => <svg key={i} className={`w-4 h-4 ${i < Math.floor(rating) ? 'text-yellow-400' : 'text-gray-300'}`} fill="currentColor" viewBox="0 0 20 20" data-id="element-570">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-571" />
              </svg>)}
          </div>
          <span className="text-sm text-gray-600" data-id="element-572">
            {rating} ({reviews})
          </span>
        </div>
        <button onClick={onTryAgent} className="bg-black text-white px-4 py-2 rounded-lg hover:bg-gray-800 transition-colors" data-id="element-573">
          Try this agent
        </button>
      </div>
    </div>;
}
function AgentCard({
  icon,
  title,
  description,
  category,
  isCustom = false,
  onViewDetails
}) {
  return <div className={`bg-white p-6 rounded-xl border ${isCustom ? 'border-black' : 'border-gray-100'} hover:shadow-sm transition-shadow`} data-id="element-574">
      <div className="flex items-center space-x-4 mb-4" data-id="element-575">
        <div className={`${isCustom ? 'bg-black' : 'bg-gray-100'} ${isCustom ? 'text-white' : 'text-black'} w-12 h-12 rounded-full flex items-center justify-center`} data-id="element-576">
          {icon}
        </div>
        <div data-id="element-577">
          <h3 className="text-xl font-semibold" data-id="element-578">{title}</h3>
          <p className="text-gray-500 text-sm" data-id="element-579">{category}</p>
        </div>
      </div>
      <p className="text-gray-600 mb-6" data-id="element-580">{description}</p>
      <button onClick={onViewDetails} className={`w-full ${isCustom ? 'bg-black text-white' : 'border border-gray-300 text-gray-700'} px-4 py-2 rounded-lg hover:bg-gray-50 transition-colors`} data-id="element-581">
        {isCustom ? 'Build Custom Agent' : 'View Details'}
      </button>
    </div>;
}